import React from 'react';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { ModalType } from '~/components/Modal/interface';
import { useModal } from '~/hooks/useModal';

import { userStore } from '~/stores';

import styles from '../UserActions.module.scss';

export const ProfileButton: React.FC = () => {
  const { openModal } = useModal();

  const handleAuth = (e: React.MouseEvent) => {
    if (userStore.isAuthorized) {
      return;
    }
    e.preventDefault();
    openModal(ModalType.Auth, 'header', {
      redirect: company.match({
        citydrinks: '/cabinet',
        default: '/cabinet/personal-data',
      }),
    });
  };

  return (
    <Link
      to={company.match({
        citydrinks: '/cabinet',
        default: '/cabinet/personal-data',
      })}
      className={styles.iconButton}
      onClick={handleAuth}
      data-link="header-cabinet"
    >
      <Icon type="profile-3.1" width={20} height={19} />
    </Link>
  );
};
